import {useEffect, useState} from 'react';

export const useFirstLoad = (): boolean => {
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    useEffect(() => {
        const hasVisited = localStorage.getItem('hasVisited');
        if (!hasVisited) {
            setIsFirstLoad(true);
            localStorage.setItem('hasVisited', 'true');
        }

        const timer = setTimeout(() => {
            setIsFirstLoad(false);
        }, 100);

        return () => clearTimeout(timer);
    }, []);

    return isFirstLoad;
};
